import React, {useState} from 'react'
import PropTypes from "prop-types"
import {
  ClickAwayListener,
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  Radio,
  RadioGroup,
  TextField
} from '@material-ui/core';
import { AboutRegistryJss } from './styleJss'
import {
  HEAR_ABOUT_US_SECTION_NAME,
  SERCOTEC_OPTION_NAME,
  CORFO_OPTION_NAME,
  OTHER_OPTION_NAME,
  CONTACT_BY_RIPLEY_OPTION_NAME,
  APANIO_PYME_OPTION_NAME,
  SOCIAL_NETWORK_OPTION_NAME,
  ASECH_OPTION_NAME,
  MEET_LATAM_OPTION_NAME,
  NONE_OPTION_NAME,
  OTHER_OPTION_MAX_LENGTH,
  CHILE
} from "../../../../constants"

const FIELD_NAME = 'hear_about_us'
const options = {
  [CONTACT_BY_RIPLEY_OPTION_NAME]: 'Fui contactado por Ripley',
  [APANIO_PYME_OPTION_NAME]: 'Apaño tu PYME',
  [SOCIAL_NETWORK_OPTION_NAME]: 'Redes Sociales',
  [ASECH_OPTION_NAME]: 'ASECH',
  [CORFO_OPTION_NAME]: 'Corfo',
  [MEET_LATAM_OPTION_NAME]: 'MEET Latam',
  [SERCOTEC_OPTION_NAME]: 'Sercotec',
  [OTHER_OPTION_NAME]: 'Otro (¿Cuál?)',
  [NONE_OPTION_NAME]: 'Ninguno',
};

const AboutRegistry = ({stateProps}) => {
  const [checksStatus, setChecksStatus] = useState({
    [CONTACT_BY_RIPLEY_OPTION_NAME]: false,
    [APANIO_PYME_OPTION_NAME]: false,
    [SOCIAL_NETWORK_OPTION_NAME]: false,
    [ASECH_OPTION_NAME]: false,
    [CORFO_OPTION_NAME]: false,
    [MEET_LATAM_OPTION_NAME]: false,
    [SERCOTEC_OPTION_NAME]: false,
    [OTHER_OPTION_NAME]: false,
    [NONE_OPTION_NAME]: false,
  });
  const classes = AboutRegistryJss();
  const handleRadioButtonChange = (event) => {
    const selectedOptionValue = event.target.value;
    const selectedOptionName = event.target.name;
    const newChecksStatus = {...checksStatus};
    newChecksStatus[CONTACT_BY_RIPLEY_OPTION_NAME] = selectedOptionValue === options[CONTACT_BY_RIPLEY_OPTION_NAME];
    newChecksStatus[APANIO_PYME_OPTION_NAME] = selectedOptionValue === options[APANIO_PYME_OPTION_NAME];
    newChecksStatus[SOCIAL_NETWORK_OPTION_NAME] = selectedOptionValue === options[SOCIAL_NETWORK_OPTION_NAME];
    newChecksStatus[ASECH_OPTION_NAME] = selectedOptionValue === options[ASECH_OPTION_NAME];
    newChecksStatus[CORFO_OPTION_NAME] = selectedOptionValue === options[CORFO_OPTION_NAME];
    newChecksStatus[MEET_LATAM_OPTION_NAME] = selectedOptionValue === options[MEET_LATAM_OPTION_NAME];
    newChecksStatus[SERCOTEC_OPTION_NAME] = selectedOptionValue === options[SERCOTEC_OPTION_NAME];
    newChecksStatus[OTHER_OPTION_NAME] = selectedOptionValue === options[OTHER_OPTION_NAME];
    newChecksStatus[NONE_OPTION_NAME] = selectedOptionName === NONE_OPTION_NAME;
    stateProps.handleSetState(CONTACT_BY_RIPLEY_OPTION_NAME, HEAR_ABOUT_US_SECTION_NAME)(newChecksStatus[CONTACT_BY_RIPLEY_OPTION_NAME])
    stateProps.handleSetState(APANIO_PYME_OPTION_NAME, HEAR_ABOUT_US_SECTION_NAME)(newChecksStatus[APANIO_PYME_OPTION_NAME])
    stateProps.handleSetState(SOCIAL_NETWORK_OPTION_NAME, HEAR_ABOUT_US_SECTION_NAME)(newChecksStatus[SOCIAL_NETWORK_OPTION_NAME])
    stateProps.handleSetState(ASECH_OPTION_NAME, HEAR_ABOUT_US_SECTION_NAME)(newChecksStatus[ASECH_OPTION_NAME])
    stateProps.handleSetState(CORFO_OPTION_NAME, HEAR_ABOUT_US_SECTION_NAME)(newChecksStatus[CORFO_OPTION_NAME])
    stateProps.handleSetState(MEET_LATAM_OPTION_NAME, HEAR_ABOUT_US_SECTION_NAME)(newChecksStatus[MEET_LATAM_OPTION_NAME])
    stateProps.handleSetState(SERCOTEC_OPTION_NAME, HEAR_ABOUT_US_SECTION_NAME)(newChecksStatus[SERCOTEC_OPTION_NAME])
    stateProps.handleSetState(OTHER_OPTION_NAME, HEAR_ABOUT_US_SECTION_NAME)(newChecksStatus[OTHER_OPTION_NAME])
    stateProps.handleSetState(NONE_OPTION_NAME, HEAR_ABOUT_US_SECTION_NAME)(newChecksStatus[NONE_OPTION_NAME])
    setChecksStatus(newChecksStatus);
    if (!newChecksStatus[OTHER_OPTION_NAME]) {
      stateProps.handleSetState(FIELD_NAME, HEAR_ABOUT_US_SECTION_NAME)(selectedOptionValue);
    } else {
      stateProps.handleSetState(FIELD_NAME, HEAR_ABOUT_US_SECTION_NAME)("");
      handleClickAway();
    }
  };

  const handleInputChange = (event) => {
    stateProps.handleSetState(FIELD_NAME, HEAR_ABOUT_US_SECTION_NAME)(event.target.value);
  }

  const handleClickAway = (event) => {
    if (stateProps.state[FIELD_NAME] === '') {
      stateProps.onRestoreErrors(HEAR_ABOUT_US_SECTION_NAME, FIELD_NAME);
    }
  };

  return (
    <Grid
      container
      item
      direction="row"
      className={classes.root}
    >
      <Grid item
          container
          direction="row" className={classes.formGrid}>
        <FormControl required component="fieldset" className={classes.formControl}>
          <FormLabel component="legend" className={classes.legend}><b>¿Cómo te enteraste de esta inscripción?</b></FormLabel>
          <RadioGroup className={classes.gridGroup}>
            <FormControlLabel
              className={classes.label}
              control={
                <Radio
                  color="primary"
                  checked={stateProps.state[CONTACT_BY_RIPLEY_OPTION_NAME]}
                  onChange={handleRadioButtonChange}
                  name={CONTACT_BY_RIPLEY_OPTION_NAME}
                  value={options[CONTACT_BY_RIPLEY_OPTION_NAME]}
                />
              }
              label={options[CONTACT_BY_RIPLEY_OPTION_NAME]}
            />
            {stateProps.country === CHILE.value ? (
              <>
                <FormControlLabel
                  className={classes.label}
                  control={
                    <Radio
                      color="primary"
                      checked={stateProps.state[APANIO_PYME_OPTION_NAME]}
                      onChange={handleRadioButtonChange}
                      name={APANIO_PYME_OPTION_NAME}
                      value={options[APANIO_PYME_OPTION_NAME]}
                    />
                  }
                  label={options[APANIO_PYME_OPTION_NAME]}
                />
                <FormControlLabel
                  className={classes.label}
                  control={
                    <Radio
                      color="primary"
                      checked={stateProps.state[ASECH_OPTION_NAME]}
                      onChange={handleRadioButtonChange}
                      name={ASECH_OPTION_NAME}
                      value={options[ASECH_OPTION_NAME]}
                    />
                  }
                  label={options[ASECH_OPTION_NAME]}
                />
                <FormControlLabel
                  className={classes.label}
                  control={
                    <Radio
                      color="primary"
                      checked={stateProps.state[CORFO_OPTION_NAME]}
                      onChange={handleRadioButtonChange}
                      name={CORFO_OPTION_NAME}
                      value={options[CORFO_OPTION_NAME]}
                    />
                  }
                  label={options[CORFO_OPTION_NAME]}
                />
                <FormControlLabel
                  className={classes.label}
                  control={
                    <Radio
                      color="primary"
                      checked={stateProps.state[MEET_LATAM_OPTION_NAME]}
                      onChange={handleRadioButtonChange}
                      name={MEET_LATAM_OPTION_NAME}
                      value={options[MEET_LATAM_OPTION_NAME]}
                    />
                  }
                  label={options[MEET_LATAM_OPTION_NAME]}
                />
                <FormControlLabel
                  className={classes.label}
                  control={
                    <Radio
                      color="primary"
                      checked={stateProps.state[SERCOTEC_OPTION_NAME]}
                      onChange={handleRadioButtonChange}
                      name={SERCOTEC_OPTION_NAME}
                      value={options[SERCOTEC_OPTION_NAME]}
                    />
                  }
                  label={options[SERCOTEC_OPTION_NAME]}
                />
              </>
            ):(
              <FormControlLabel
                className={classes.label}
                control={
                  <Radio
                    color="primary"
                    checked={stateProps.state[SOCIAL_NETWORK_OPTION_NAME]}
                    onChange={handleRadioButtonChange}
                    name={SOCIAL_NETWORK_OPTION_NAME}
                    value={options[SOCIAL_NETWORK_OPTION_NAME]}
                  />
                }
                label={options[SOCIAL_NETWORK_OPTION_NAME]}
              />
            )}
            <FormControlLabel
              className={classes.label}
              control={
                <Radio
                  color="primary"
                  checked={stateProps.state[NONE_OPTION_NAME]}
                  onChange={handleRadioButtonChange}
                  name={NONE_OPTION_NAME}
                  value={options[NONE_OPTION_NAME]}
                />
              }
              label={options[NONE_OPTION_NAME]}
            />
            <FormControlLabel
              className={classes.label}
              control={
                <Radio
                  color="primary"
                  checked={stateProps.state[OTHER_OPTION_NAME]}
                  onChange={handleRadioButtonChange}
                  name={OTHER_OPTION_NAME}
                  value={options[OTHER_OPTION_NAME]}
                />
              }
              label={options[OTHER_OPTION_NAME]}
            />
          </RadioGroup>
          { stateProps.state[OTHER_OPTION_NAME] &&
            <ClickAwayListener onClickAway={handleClickAway}>
              <TextField
                fullWidth
                id="other-registry"
                placeholder="Escribe otra opción"
                variant="outlined"
                size="small"
                onChange={handleInputChange}
                error={stateProps.errors.hear_about_us !== undefined && stateProps.errors.hear_about_us !== ''}
                helperText={stateProps.errors.hear_about_us}
                inputProps={{
                  maxLength: OTHER_OPTION_MAX_LENGTH
                }}
              />
            </ClickAwayListener>
          }
        </FormControl>
      </Grid>
    </Grid>
  )
}

AboutRegistry.propTypes = {
  stateProps: PropTypes.exact({
    state: PropTypes.exact({
      [CONTACT_BY_RIPLEY_OPTION_NAME]: PropTypes.bool.isRequired,
      [APANIO_PYME_OPTION_NAME]: PropTypes.bool.isRequired,
      [SOCIAL_NETWORK_OPTION_NAME]: PropTypes.bool.isRequired,
      [ASECH_OPTION_NAME]: PropTypes.bool.isRequired,
      [CORFO_OPTION_NAME]: PropTypes.bool.isRequired,
      [MEET_LATAM_OPTION_NAME]: PropTypes.bool.isRequired,
      [SERCOTEC_OPTION_NAME]: PropTypes.bool.isRequired,
      [OTHER_OPTION_NAME]: PropTypes.bool.isRequired,
      [NONE_OPTION_NAME]: PropTypes.bool.isRequired,
      hear_about_us: PropTypes.string.isRequired,
    }),
    country: PropTypes.string.isRequired,
    setState: PropTypes.func.isRequired,
    handleSetState: PropTypes.func.isRequired,
    errors: PropTypes.exact({
      hear_about_us: PropTypes.string,
    }),
    onRestoreErrors: PropTypes.func,
  }).isRequired,
}

export default AboutRegistry
